import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, switchMap, throwError } from 'rxjs';
import Keycloak from 'keycloak-js';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const keycloak = inject(Keycloak);

  // No token available — send request without auth
  if (!keycloak.token) {
    return next(req);
  }

  const attachTokenAndSend = (token: string) => {
    return next(req.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    }));
  };

  // Refresh token if expired or expiring within 30 seconds
  if (keycloak.isTokenExpired(30)) {
    return from(keycloak.updateToken(30)).pipe(
      switchMap(() => attachTokenAndSend(keycloak.token!)),
      catchError(() => throwError(() => new Error('Token refresh failed')))
    );
  }

  return attachTokenAndSend(keycloak.token);
};
